import { Injectable } from '@angular/core';
import { usesJson } from '../data/uses.json';
import { citiesJson } from '../data/cities.json';
import { catchError, concatMap, filter, forkJoin, map, mergeMap, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { City, District, Prop, Province } from '../interfaces/prop.interface';
import { districtsJson } from '../data/districts.json';
import { propsJson } from '../data/props.json';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { provincesJson } from '../data/provinces.json';

@Injectable({
  providedIn: 'root'
})
export class PropertiespreService {

  resultCount: number = 0;
  result: Prop[] = [];
  props: any;
  props2: any;

  endpointApi = environment.apiPropUrl;
  provinces: any;
  subProvinces: any[] = [];
  provinces2: any;
  provinces3: any;
  cities: any;
  subCities: any[] = [];
  cities2: any;
  cities3: any;
  districts: any;
  districts2: any;
  districts3: any;
  subDistricts: any[] = [];

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  // Get uses
  getUses() {
    return usesJson;
  }

  // Get provinces
  getProvinces() {
    this.provinces = this.http.get<Province>(this.endpointApi + 'provinces');
    return this.provinces;
  }

  // Get provinces by use & search4
  getProvincesByUse(strategy: any, use: any): Observable<any> {

    if (!strategy) {
      return of([]);
    }
    this.provinces2 = provincesJson;
    this.provinces3 = [];
    this.subProvinces = [];
    let useUrl = "use=" + use
    if (use == "0" || use == "" || use == null) {
      useUrl = "";
    }
    let i = 0
    return this.http.get<any>(this.endpointApi + 'property/search?' + useUrl + '&strategy=' + strategy + '&size=1000' + '&visible=1' + '&active=1')
      .pipe(
        map(resp => {
          // Recorremos todas las propiedades encontradas
          for (const prop of resp.data.properties.rows) {
            // Si la provincia no está en el array subProvinces, la añade
            if (!this.subProvinces.find(province => province === prop.province)) {
              this.subProvinces.push(prop.province);
            }
          }
          // Recorremos el array de subProvinces
          for (const prov of this.subProvinces) {
            // Por cada provincia, obtenemos toda la información

            this.provinces3.push(this.provinces2.find(province => province.id == prov.toString()))
            i++;
            if (i === this.subProvinces.length) {

              this.provinces3.sort(function (a, b) {
                var provinciaA = a.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                var provinciaB = b.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                if (provinciaA < provinciaB) {
                  return -1;
                }
                if (provinciaA > provinciaB) {
                  return 1;
                }
                return 0;
              });





              // this.provinces3.forEach(province => {
              //   province.name = this.deleteAccents(province.name)
              // });


              // this.provinces3.sort((a, b) => (a.name! < b.name! ? -1 : 1))
            }
          }
          return this.provinces3

        }),
        catchError(this.handleError)
      )
  }

  // Get cities by province & use & search4
  getCitiesByUse(fk_idProvince: any, strategy: any, use: any) {
    if (!strategy || !fk_idProvince) {
      return of([]);
    }
    this.cities2 = citiesJson;
    this.cities3 = []
    this.subCities = []
    let useUrl = "use=" + use
    if (use == "0" || use == "" || use == null) {
      useUrl = "";
    }
    let i = 0
    return this.http.get<any>(this.endpointApi + 'property/search?' + useUrl + '&strategy=' + strategy + '&size=10000' + '&province=' + fk_idProvince)
      .pipe(
        map(resp => {
          // Recorremos todas las propiedades encontradas
          for (const prop of resp.data.properties.rows) {

            if (prop.active && prop.visible) {
              // Si la city no está en el array subCities, la añade
              if (!this.subCities.find(city => city === prop.city)) {
                // console.log(prop.city)
                this.subCities.push(prop.city);
              }
            }
          }
          // Recorremos el array de subCities
          // Por cada city, obtenemos toda la información

          for (const cit of this.subCities) {
            // Por cada provincia, obtenemos toda la información

            this.cities3.push(this.cities2.find(city => city.id == cit.toString()))
            i++;
            if (i === this.subCities.length) {
              this.cities3.sort((a, b) => (a.name! < b.name! ? -1 : 1))
            }

          }
          return this.cities3
        }),
        catchError(this.handleError)
      )
  }


  // Get cities
  getCities(fk_idProvince: any): Observable<any> {
    if (!fk_idProvince) {
      fk_idProvince = '999';
    }
    return this.http.get<any>(this.endpointApi + 'cities?provinceId=' + fk_idProvince)
      .pipe(
        map(resp => resp.data.cities),
        catchError(this.handleError)
      )

  }

  // Get districts
  getDistricts(fk_idCity: any): Observable<District[]> {
    if (!fk_idCity) {
      fk_idCity = '999';
    }
    return this.districts = this.http.get<any>(this.endpointApi + 'districts?cityId=' + fk_idCity)
      .pipe(
        map(resp => {
          return resp.data.districts.map(district => {
            district.id = district.id.toString();
            return district;
          });
        }),
        catchError(this.handleError)
      );

  }

  // Get districts by city, province & use & search4
  getDistrictsByCity(fk_idProvince: any, strategy: any, use: any, fk_idCity: any) {
    if (!strategy || !fk_idProvince) {
      return of([]);
    }
    this.districts2 = districtsJson;
    this.districts3 = []
    this.subDistricts = []
    let useUrl = "use=" + use
    if (use == "0" || use == "" || use == null) {
      useUrl = "";
    }
    let i = 0
    if (!fk_idCity) {
      fk_idCity = '999';
    }

    return this.http.get<any>(this.endpointApi + 'property/search?' + useUrl + '&strategy=' + strategy + '&size=10000' + '&province=' + fk_idProvince + '&city=' + fk_idCity + '&visible=1' + '&active=1')
      .pipe(
        map(resp => {
          this.subDistricts = []
          this.districts3 = []
          for (const prop of resp.data.properties.rows) {

            if (!this.subDistricts.find(district => district === prop.district)) {

              if (prop.district && prop.district !== null && prop.district !== undefined && prop.district !== "" && prop.district !== "0") {
                this.subDistricts.push(prop.district);
              }
            }

            // if (!this.subDistricts.includes(prop.district) && prop.district != null && prop.district != undefined && prop.district != "" && prop.district != "0") {
            //   this.subDistricts.push(prop.district.toString());
            // }


          }

          for (const dist of this.subDistricts) {
            // Por cada provincia, obtenemos toda la información


            this.districts3.push(this.districts2.find(district => district.id == dist.toString()))
            // i++;
            // if (i === this.subDistricts.length) {
            //   this.districts3.sort((a, b) => (a.name! < b.name! ? -1 : 1))
            // }


          }
          this.subDistricts = []

          this.subDistricts = this.districts3.filter(el => el !== undefined)

          return this.subDistricts

          // return resp.data.districts.map(district => {
          //   district.id = district.id.toString();
          //   return district;
          // });
        }),
        catchError(this.handleError)
      );

  }


  getPropsCount(isSearch4: string, fk_idUse: string, fk_idProvince: string, fk_idCity: string, fk_idDistrict: string): Observable<any> {

    if (!fk_idProvince) { return of(0) }
    let params = '';

    let useUrl = "use=" + fk_idUse
    if (fk_idUse == "0" || fk_idUse == "" || fk_idUse == null) {
      useUrl = "";
    }

    if (fk_idDistrict) {
      params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince + '&city=' + fk_idCity + '&district=' + fk_idDistrict;
    }
    else if (fk_idCity) {
      params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince + '&city=' + fk_idCity;
    }
    else {
      params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince;
    }

    params = params + '&size=10000' + '&visible=1' + '&active=1'
    return this.http.get<any>(this.endpointApi + 'property/search?' + useUrl + params)
      .pipe(
        map(resp => resp.data.properties),
        catchError(this.handleError)
      );
  }

  getProps(surfaces: any, smoke: boolean, isSearch4: string, fk_idUse: string, fk_idProvince: string, fk_idCity: string, fk_idDistrict: string): Observable<any> {
    let params = '';
    let useUrl = "use=" + fk_idUse
    if (fk_idUse == "0" || fk_idUse == "" || fk_idUse == null) {
      useUrl = "";
    }
    if (!fk_idProvince) { params = params + '&strategy=' + isSearch4 }
    else
      if (fk_idDistrict) {
        params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince + '&city=' + fk_idCity + '&district=' + fk_idDistrict;
      }
      else if (fk_idCity) {
        params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince + '&city=' + fk_idCity;
      }
      else {
        params = params + '&strategy=' + isSearch4 + '&province=' + fk_idProvince;
      }

    if (smoke === true) {
      params = params + '&smokeStractor=true'
    }
    if (surfaces) {
      params = params + '&surfaceTotalmin=' + surfaces.surfaceTotalmin + '&surfaceTotalmax=' + surfaces.surfaceTotalmax
      params = params + '&surfacebrmin=' + surfaces.surfacebrmin + '&surfacebrmax=' + surfaces.surfacebrmax
      params = params + '&surfacepbmin=' + surfaces.surfacepbmin + '&surfacepbmax=' + surfaces.surfacepbmax
      params = params + '&surfaceMezzaninemin=' + surfaces.surfaceMezzaninemin + '&surfaceMezzaninemax=' + surfaces.surfaceMezzaninemax
      params = params + '&surfaceBasement1min=' + surfaces.surfaceBasement1min + '&surfaceBasement1max=' + surfaces.surfaceBasement1max
      params = params + '&surfaceBasement2min=' + surfaces.surfaceBasement2min + '&surfaceBasement2max=' + surfaces.surfaceBasement2max
    }

    params = params + '&size=10000' + '&visible=1' + '&active=1'


    return this.http.get<any>(this.endpointApi + 'property/search?' + useUrl + params)
      .pipe(
        mergeMap(prop => {
          let prop2 = prop.data.properties.rows;
          // prop2.forEach(element => {
          //   element.images = []
          //   this.getImagesById(element.id).subscribe(resp => {
          //     element.images = resp
          //   })
          // })
          return of(prop2)
        }),

        catchError(error => {
          console.log(error);
          return of(null);
        })
      );
  }

  deleteAccents(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }

  getImagesById(id: string) {
    return this.http.get<any>(this.endpointApi + 'images/get?fk_idProp=' + id)
      .pipe(
        map(resp => resp.data.images.rows),
        catchError(this.handleError)
      )
  }

}
